(function(){
"use strict";
window.WAGLIFE_PLACE_IQ_BUILD="V3_BACKEND_SPLIT";

var root=document.getElementById("wl-place-page");
if(!root)return;
var config=window.WagLifePlaceIQConfig||{};
var mapboxToken=String(config.mapboxToken||"");
var params=new URLSearchParams(window.location.search);
var place={
name:params.get("place") || "Selected Place",
id:params.get("id") || "",
lng:Number(params.get("lng")),
lat:Number(params.get("lat")),
address:params.get("address") || "Address not available",
category:params.get("category") || "Place",
source:params.get("source") || "mapbox"
};
var hasValidCoordinates=isFinite(place.lng) && isFinite(place.lat) && params.get("lng")!==null && params.get("lat")!==null;
if(!hasValidCoordinates){
place.lng=-89.984;
place.lat=34.991;
}
var placeCoordinates=[place.lng,place.lat];
var safeName=place.name.replace(/[<>]/g,"");
var mapQuery=encodeURIComponent(place.name);
var appleMapsView="https://maps.apple.com/?ll="+place.lat+","+place.lng+"&q="+mapQuery;
var appleMapsDirections="https://maps.apple.com/?daddr="+place.lat+","+place.lng+"&q="+mapQuery;
var driveIQParams=new URLSearchParams();
driveIQParams.set("name",String(place.name||"WagLife Destination"));
driveIQParams.set("lat",String(place.lat));
driveIQParams.set("lng",String(place.lng));
driveIQParams.set("address",String(place.address||""));
driveIQParams.set("category",String(place.category||"Place"));
driveIQParams.set("placeId",String(place.id||""));
driveIQParams.set("source","waglife");
var driveIQDestinationURL="waglife://route?"+driveIQParams.toString();
function text(selector,value){
var element=root.querySelector(selector);
if(element)element.textContent=value;
}
function href(selector,value){
var element=root.querySelector(selector);
if(element)element.href=value;
}
function categoryLabel(value){
return String(value||"Place")
.replace(/[_-]+/g," ")
.replace(/\b\w/g,function(letter){return letter.toUpperCase();});
}
text("#wl-place-name",place.name);
text("#wl-place-eyebrow","PLACE IQ · "+categoryLabel(place.category).toUpperCase());
text("#wl-place-summary",
"A real mapped result near "+place.address+
". WagLife is verifying dog access, visit details, and current conditions before making a stronger recommendation."
);
text("#wl-place-address-meta","📍 "+place.address);
text("#wl-place-source-meta","Source: "+categoryLabel(place.source));
text("#wl-place-address-detail",place.address);
text("#wl-place-category-detail",categoryLabel(place.category));
text("#wl-place-source-detail",categoryLabel(place.source)+" search result");
text("#wl-place-id-detail",place.id ? "ID available" : "No place ID");
text("#wl-place-map-name",place.name);
text("#wl-place-map-address",place.address);
text("#wl-place-final-title","Review "+place.name+" before heading out.");
text("#wl-place-final-copy",
"Check the real map location, current Weather IQ, and any available visit information before leaving."
);
href("#wl-place-route-primary",driveIQDestinationURL);
href("#wl-place-open-maps",appleMapsView);
href("#wl-place-directions",appleMapsDirections);
href("#wl-place-final-route",driveIQDestinationURL);
var mapContainer=root.querySelector("#wl-place-map");
var mapLoading=root.querySelector("#wl-place-map-loading");
function initializePlaceMap(){
if(!mapContainer || typeof mapboxgl==="undefined"){
if(mapLoading){
mapLoading.innerHTML="<span>🐾</span><strong>Map unavailable</strong>";
}
return;
}
if(!mapboxgl.supported()){
if(mapLoading){
mapLoading.innerHTML="<span>🐾</span><strong>This device cannot display the interactive map.</strong>";
}
return;
}
mapboxgl.accessToken=mapboxToken;
var placeMap=new mapboxgl.Map({
container:mapContainer,
style:"mapbox://styles/mapbox/standard",
center:placeCoordinates,
zoom:14.5,
pitch:42,
bearing:-12,
attributionControl:true
});
placeMap.addControl(
new mapboxgl.NavigationControl({showCompass:true,showZoom:true}),
"top-right"
);
placeMap.addControl(
new mapboxgl.GeolocateControl({
positionOptions:{enableHighAccuracy:true},
trackUserLocation:false,
showUserHeading:true
}),
"top-right"
);
var markerElement=document.createElement("div");
markerElement.className="wl-place-map-marker";
markerElement.setAttribute("aria-label",place.name+" map marker");
markerElement.textContent="🐾";
var popup=new mapboxgl.Popup({
offset:28,
closeButton:false,
className:"wl-place-map-popup"
}).setHTML(
"<strong>"+safeName+"</strong>"+
"<span>Dog access not yet verified</span>"
);
new mapboxgl.Marker({element:markerElement,anchor:"center"})
.setLngLat(placeCoordinates)
.setPopup(popup)
.addTo(placeMap);
placeMap.on("load",function(){
if(mapLoading)mapLoading.classList.add("is-hidden");
window.setTimeout(function(){placeMap.resize();},100);
});
placeMap.on("error",function(){
if(mapLoading && !mapLoading.classList.contains("is-hidden")){
mapLoading.innerHTML="<span>🐾</span><strong>The map could not be loaded.</strong>";
}
});
}
initializePlaceMap();
function weatherCodeInfo(code,isDay){
var map={
0:["Clear",isDay ? "☀️" : "🌙"],
1:["Mostly clear",isDay ? "🌤️" : "🌙"],
2:["Partly cloudy","⛅"],
3:["Cloudy","☁️"],
45:["Fog","🌫️"],
48:["Freezing fog","🌫️"],
51:["Light drizzle","🌦️"],
53:["Drizzle","🌦️"],
55:["Heavy drizzle","🌧️"],
61:["Light rain","🌦️"],
63:["Rain","🌧️"],
65:["Heavy rain","🌧️"],
71:["Light snow","🌨️"],
73:["Snow","🌨️"],
75:["Heavy snow","❄️"],
80:["Rain showers","🌦️"],
81:["Rain showers","🌧️"],
82:["Heavy showers","⛈️"],
95:["Thunderstorm","⛈️"],
96:["Thunderstorm with hail","⛈️"],
99:["Severe thunderstorm with hail","⛈️"]
};
return map[code] || ["Changing conditions","🌤️"];
}
function formatHour(iso){
var date=new Date(iso);
return date.toLocaleTimeString([],{
hour:"numeric",
minute:"2-digit"
});
}
function buildGuidance(current,nextHours){
var maxRain=Math.max.apply(null,nextHours.map(function(hour){
return Number(hour.rain)||0;
}));
var thunder=nextHours.some(function(hour){
return [95,96,99].indexOf(Number(hour.code))>-1;
});
var maxWind=Math.max.apply(null,nextHours.map(function(hour){
return Number(hour.wind)||0;
}));
var temp=Number(current.temperature);
var feels=Number(current.apparent);
if(thunder){
return {
level:"urgent",
text:"Thunderstorms are forecast near this place during the next few hours. Consider postponing the outing and follow official severe-weather guidance."
};
}
if(maxRain>=65){
return {
level:"warning",
text:"Rain is likely during the next few hours. Keep the outing short and make sure you can return to shelter quickly."
};
}
if(feels>=95){
return {
level:"urgent",
text:"Dangerous heat may be uncomfortable for many dogs. Consider postponing, choosing a cooler time, or keeping the outing very short with water and shade."
};
}
if(feels>=85){
return {
level:"warning",
text:"Warm conditions may become uncomfortable for Scout. Prefer shade, bring water, and consider a shorter outing."
};
}
if(maxWind>=25){
return {
level:"warning",
text:"Strong winds are possible. Watch for falling branches, loose objects, and rapidly changing conditions."
};
}
if(maxRain>=35){
return {
level:"warning",
text:"Showers are possible during the outing window. Check the hourly forecast and keep a quick return option."
};
}
return {
level:"good",
text:"Conditions look generally reasonable for a short outing, but weather can change quickly. Keep water available and watch your dog and surroundings."
};
}
function loadWeather(){
var tempEl=root.querySelector("#wl-place-weather-temp");
var conditionEl=root.querySelector("#wl-place-weather-condition");
var iconEl=root.querySelector("#wl-place-weather-icon");
var feelsEl=root.querySelector("#wl-place-weather-feels");
var rainEl=root.querySelector("#wl-place-weather-rain");
var windEl=root.querySelector("#wl-place-weather-wind");
var updatedEl=root.querySelector("#wl-place-weather-updated");
var guidanceEl=root.querySelector("#wl-place-weather-guidance");
var hourlyEl=root.querySelector("#wl-place-hourly");
var fitCopy=root.querySelector("#wl-place-weather-fit-copy");
var opinion=root.querySelector("#wl-place-opinion-copy");
var confidenceScore=root.querySelector("#wl-place-confidence-score");
var confidenceLabel=root.querySelector("#wl-place-confidence-label");
var confidenceCopy=root.querySelector("#wl-place-confidence-copy");
var dataConfidence=root.querySelector("#wl-place-data-confidence");
try{
var query=new URLSearchParams({
latitude:String(place.lat),
longitude:String(place.lng),
current:[
"temperature_2m",
"apparent_temperature",
"is_day",
"precipitation",
"weather_code",
"wind_speed_10m"
].join(","),
hourly:[
"temperature_2m",
"apparent_temperature",
"precipitation_probability",
"weather_code",
"wind_speed_10m"
].join(","),
temperature_unit:"fahrenheit",
wind_speed_unit:"mph",
precipitation_unit:"inch",
timezone:"auto",
forecast_days:"2"
});
fetch("https://api.open-meteo.com/v1/forecast?"+query.toString())
.then(function(response){
if(!response.ok){
throw new Error("Weather request failed");
}
return response.json();
})
.then(function(data){
var current=data.current;
var currentIndex=data.hourly.time.findIndex(function(time){
return time>=current.time;
});
if(currentIndex<0)currentIndex=0;
var nextHours=[];
for(var i=currentIndex;i<Math.min(currentIndex+4,data.hourly.time.length);i++){
nextHours.push({
time:data.hourly.time[i],
temperature:data.hourly.temperature_2m[i],
apparent:data.hourly.apparent_temperature[i],
rain:data.hourly.precipitation_probability[i],
code:data.hourly.weather_code[i],
wind:data.hourly.wind_speed_10m[i]
});
}
var info=weatherCodeInfo(Number(current.weather_code),Boolean(current.is_day));
tempEl.textContent=Math.round(current.temperature_2m)+"°";
conditionEl.textContent=info[0];
iconEl.textContent=info[1];
feelsEl.textContent="Feels like "+Math.round(current.apparent_temperature)+"°";
rainEl.textContent="Rain "+Math.round(nextHours[0] ? nextHours[0].rain : 0)+"%";
windEl.textContent="Wind "+Math.round(current.wind_speed_10m)+" mph";
updatedEl.textContent="Updated "+new Date(current.time).toLocaleTimeString([],{
hour:"numeric",
minute:"2-digit"
});
hourlyEl.innerHTML="";
nextHours.forEach(function(hour){
var hourInfo=weatherCodeInfo(Number(hour.code),true);
var item=document.createElement("div");
item.innerHTML=
"<strong>"+formatHour(hour.time)+"</strong>"+
"<span>"+hourInfo[1]+"</span>"+
"<small>"+Math.round(hour.temperature)+"° · "+Math.round(hour.rain)+"% rain</small>";
hourlyEl.appendChild(item);
});
hourlyEl.hidden=false;
var currentSummary={
temperature:current.temperature_2m,
apparent:current.apparent_temperature
};
var guidance=buildGuidance(currentSummary,nextHours);
guidanceEl.classList.remove("is-warning","is-urgent");
if(guidance.level==="warning")guidanceEl.classList.add("is-warning");
if(guidance.level==="urgent")guidanceEl.classList.add("is-urgent");
guidanceEl.textContent=guidance.text;
fitCopy.textContent=guidance.text;
opinion.textContent=
"This is a real mapped result. Current Weather IQ is available, while dog policy, hours, amenities, and community conditions still need verification.";
confidenceScore.textContent="60";
confidenceLabel.textContent="Moderate data confidence";
confidenceCopy.textContent=
"Real place identity, coordinates, map, routing, and current weather are available. Dog access and detailed visit conditions remain unverified.";
dataConfidence.textContent="Moderate data";
})
.catch(function(error){
updatedEl.textContent="Weather unavailable";
guidanceEl.textContent=
"Current weather could not be loaded. Check a trusted weather source before heading out.";
guidanceEl.classList.add("is-warning");
fitCopy.textContent=
"Current Weather IQ is unavailable. Check a trusted forecast before visiting.";
confidenceScore.textContent="40";
confidenceLabel.textContent="Limited data confidence";
confidenceCopy.textContent=
"The map location is available, but current weather and detailed visit conditions could not be verified.";
dataConfidence.textContent="Limited data";
});
}catch(error){
updatedEl.textContent="Weather unavailable";
guidanceEl.textContent=
"Current weather could not be loaded. Check a trusted weather source before heading out.";
guidanceEl.classList.add("is-warning");
fitCopy.textContent=
"Current Weather IQ is unavailable. Check a trusted forecast before visiting.";
confidenceScore.textContent="40";
confidenceLabel.textContent="Limited data confidence";
confidenceCopy.textContent=
"The map location is available, but current weather and detailed visit conditions could not be verified.";
dataConfidence.textContent="Limited data";
}
}
loadWeather();
function openDriveIQRoute(event){
if(event)event.preventDefault();
if(!hasValidCoordinates){
window.location.href=appleMapsDirections;
return;
}
window.location.href=driveIQDestinationURL;
}
var primaryRouteButton=root.querySelector("#wl-place-route-primary");
var finalRouteButton=root.querySelector("#wl-place-final-route");
if(primaryRouteButton){
primaryRouteButton.addEventListener("click",openDriveIQRoute);
}
if(finalRouteButton){
finalRouteButton.addEventListener("click",openDriveIQRoute);
}

var saved=false;
var toast=root.querySelector("#wl-place-toast");
function showToast(message){
toast.textContent=message;
toast.hidden=false;
window.clearTimeout(showToast.timer);
showToast.timer=window.setTimeout(function(){
toast.hidden=true;
},2200);
}
function setSaved(nextValue){
saved=nextValue;
[
root.querySelector("#wl-place-save"),
root.querySelector("#wl-place-save-top"),
root.querySelector("#wl-place-final-save")
].forEach(function(button){
if(!button)return;
button.classList.toggle("is-saved",saved);
if(button.id==="wl-place-save"){
button.textContent=saved ? "♥ Saved" : "♡ Save Place";
}else if(button.id==="wl-place-save-top"){
button.textContent=saved ? "♥ Saved" : "♡ Save";
}else{
button.textContent=saved ? "Saved to Favorites" : "Save for Later";
}
});
showToast(
saved
? place.name+" saved to Favorites."
: place.name+" removed from Favorites."
);
}
root.querySelector("#wl-place-save").addEventListener("click",function(){
setSaved(!saved);
});
root.querySelector("#wl-place-save-top").addEventListener("click",function(){
setSaved(!saved);
});
root.querySelector("#wl-place-final-save").addEventListener("click",function(){
setSaved(!saved);
});
root.querySelector("#wl-place-share").addEventListener("click",function(){
var shareData={
title:place.name,
text:"Take a look at "+place.name+" in WagLife.",
url:window.location.href
};
if(navigator.share){
navigator.share(shareData).catch(function(){});
}else if(navigator.clipboard){
navigator.clipboard.writeText(window.location.href).then(function(){
showToast("Place link copied.");
});
}else{
showToast("Share link ready.");
}
});
root.querySelector("#wl-place-listen").addEventListener("click",function(){
var guidance=root.querySelector("#wl-place-weather-guidance").textContent;
var speech=
place.name+". "+place.address+". "+
"Dog access has not yet been verified. "+
guidance;
if("speechSynthesis" in window){
window.speechSynthesis.cancel();
window.speechSynthesis.speak(new SpeechSynthesisUtterance(speech));
showToast("Playing Place IQ summary.");
}else{
showToast("Audio summary is not available on this device.");
}
});
root.querySelectorAll(".wl-place-save-list button").forEach(function(button){
button.addEventListener("click",function(){
button.classList.toggle("is-active");
showToast(
button.classList.contains("is-active")
? "Added to "+button.textContent+"."
: "Removed from "+button.textContent+"."
);
});
});
var modal=root.querySelector("#wl-place-report-modal");
})();